import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { usePumpStatuses } from "./usePumpStatuses"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"

export function usePumpStatus(accountId?: PumpStatus["account_id"]) {
  const { data: pumpStatuses } = usePumpStatuses()
  const { currentUserId } = useFollowedUsers()

  const currentAccountId = accountId ?? currentUserId

  return useMemo(
    () => pumpStatuses?.find(
      (cachedPumpStatus) => cachedPumpStatus.account_id === currentAccountId,
    ),
    [
      pumpStatuses,
      currentAccountId,
    ],
  )
}
